module.exports = __webpack_public_path__ + "img/taptap-home.3a6a9ea4.png";